module.exports = __webpack_public_path__ + "img/scene27.d28b6e28.gif";